import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getPersonName from "../common/Name";
import { getDate } from "../common/DisplayDate";
import Address from "./Address";

class FederalFirearmRecordDetail extends Component {
  componentDidMount() {}

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      const nameNode = _.get(node, "licenseNames[0].name[0]");
      results.push(
        <Table.Row key={`FedFire_Record_Name_Row_${this.props.index}`}>
          <Table.Cell>Name:</Table.Cell>
          <Table.Cell>
            {nameNode &&
              getPersonName(
                _.get(nameNode, "first[0]._", ""),
                "",
                _.get(nameNode, "last[0]._", ""),
                this.props
              )}
          </Table.Cell>
          <Table.Cell>IRS Region:</Table.Cell>
          <Table.Cell>{_.get(node, "IRSRegion[0]._", "")}</Table.Cell>
        </Table.Row>
      );

      results.push(
        <Table.Row key={`FedFire_Record_Trade_Row_${this.props.index}`}>
          <Table.Cell>Trade Name:</Table.Cell>
          <Table.Cell>{_.get(node, "tradeName[0]._", "")}</Table.Cell>
          <Table.Cell>Type:</Table.Cell>
          <Table.Cell>{_.get(node, "licenseType[0]._", "")}</Table.Cell>
        </Table.Row>
      );

      results.push(
        <Table.Row key={`FedFire_Record_Address_Row_${this.props.index}`}>
          <Table.Cell>Mailing Address:</Table.Cell>
          <Table.Cell>
            <Address
              addressNode={_.get(node, "mailingAddress[0]")}
              {...this.props}
            />
          </Table.Cell>
          <Table.Cell>License Number:</Table.Cell>
          <Table.Cell>{_.get(node, "licenseNumber[0]._", "")}</Table.Cell>
        </Table.Row>
      );

      results.push(
        <Table.Row
          key={`FedFire_Record_Premise_Address_Row_${this.props.index}`}
        >
          <Table.Cell>Premise Address:</Table.Cell>
          <Table.Cell>
            <Address
              addressNode={_.get(node, "premiseAddress[0]")}
              {...this.props}
            />
          </Table.Cell>
          <Table.Cell>Issue State:</Table.Cell>
          <Table.Cell>{_.get(node, "licenseIssueState[0]._", "")}</Table.Cell>
        </Table.Row>
      );

      results.push(
        <Table.Row key={`FedFire_Record_Phone_Row_${this.props.index}`}>
          <Table.Cell>Phone:</Table.Cell>
          <Table.Cell>{_.get(node, "businessPhone[0]._", "")}</Table.Cell>
          <Table.Cell>Expiration Date:</Table.Cell>
          <Table.Cell>
            {getDate(_.get(node, "licenseExpireDate[0]"))}
          </Table.Cell>
        </Table.Row>
      );

      results.push(
        <Table.Row key={`FedFire_Record_Ssn_Row_${this.props.index}`}>
          <Table.Cell>SSN:</Table.Cell>
          <Table.Cell>{_.get(node, "SSN[0]._", "")}</Table.Cell>
          <Table.Cell>County:</Table.Cell>
          <Table.Cell>{_.get(node, "countyName[0]._", "")}</Table.Cell>
        </Table.Row>
      );
    }

    return (
      <Table>
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default FederalFirearmRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/FederalFirearmRecordDetail.js